import React from 'react';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

const ResetAppCache = () => {
  const handleReset = () => {
    if (typeof window === 'undefined') return;
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.clear();
      }

      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.clear();
      }

      if ('caches' in window) {
        caches
          .keys()
          .then((names) =>
            Promise.all(names.map((name) => caches.delete(name))),
          )
          .catch((err) => console.warn('Error deleting cache entries:', err));
      }

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          for (const reg of registrations) {
            reg.unregister();
          }
        });
      }
    } catch (err) {
      console.warn('Error clearing app cache:', err);
    } finally {
      window.location.reload();
    }
  };

  return (
    <div className='flex flex-col items-center justify-center h-full  py-40 text-white px-4 text-center'>
      <h1 className='text-xl md:text-2xl font-semibold mb-4'>
        Something went wrong
      </h1>
      <p className='mb-6 text-xs md:text-sm text-grayZl-500 max-w-md'>
        It seems like cached browser data is causing an issue. You can try
        clearing it to reload a fresh version of the site.
      </p>

      <ButtonDefault
        size={4}
        variant={ButtonVariants.PRIMARY}
        className='w-min p-1'
        onClick={handleReset}
      >
        <span className='flex text-sm gap-x-2 px-4  whitespace-nowrap'>
          Clear Cache & Reload
        </span>
      </ButtonDefault>
    </div>
  );
};

export default ResetAppCache;
